module.exports = __webpack_public_path__ + "static/media/help.a8668630.svg";